import React from 'react';
import { humanTimeDiff } from '../../utils/dateUtil';
import { buildPickupLocation, mapConditionToLabel } from '../../utils/classifiedUtil';
/**
 * Helper component to render the editable contents of
 * a Classified
 * */
export var EditableContent = function () { return React.createElement(React.Fragment, null,
    React.createElement("button", { key: "action-edit", "data-action": "edit" }, "Endre"),
    React.createElement("button", { key: "action-delete", className: "dangerous", "data-action": "delete" }, "Slett")); };
var ConversationButton = function (_a) {
    var slug = _a.slug, classifiedId = _a.classifiedId;
    return React.createElement("a", { className: "button is-flat-link has-fas", href: "/chat/" + slug + "?interested_in=" + (classifiedId || '') },
        React.createElement("span", null, "G\u00E5 til samtale"),
        React.createElement("i", { className: "fas fa-arrow-right" }));
};
var ContactSellerButtonChat = function (_a) {
    var classified = _a.classified, isOwnedByUser = _a.isOwnedByUser, onUserContact = _a.onUserContact;
    // What possible actions the user gets, is dependant on previous interactions and ownership
    // of a classified.
    var actionButton = React.createElement("button", { onClick: function () { return onUserContact(classified); }, key: "action", className: "button" }, "Kontakt selger");
    if (isOwnedByUser) {
        actionButton = React.createElement("button", { key: "action", className: "is-flat-link", disabled: true }, "Din annonse");
    }
    else if (classified.conversation) {
        actionButton = React.createElement(ConversationButton, { slug: classified.conversation.slug, classifiedId: classified.id });
    }
    return actionButton;
};
/**
 * Helper-component to render the non-editable contents of
 * a Classified
 * @return {array}
 * */
export var NonEditableContent = function (props) {
    var classified = props.classified, onUserContact = props.onUserContact, _a = props.isOwnedByUser, isOwnedByUser = _a === void 0 ? false : _a;
    var actionButton = React.createElement(ContactSellerButtonChat, { classified: classified, onUserContact: onUserContact, isOwnedByUser: isOwnedByUser });
    return React.createElement(React.Fragment, null,
        classified.hasVipps
            ? React.createElement("div", { key: "extra", className: "horizontal nowrap" }, classified.hasVipps && React.createElement("a", { key: "vipps", href: "hjelp#vipps", className: "icon vipps nohover", title: "Selgeren st\u00F8tter betaling gjennom vipps" }, " ")) : React.createElement(React.Fragment, null),
        React.createElement("div", { key: "condition", className: "vertical vertical-center" },
            React.createElement("strong", { className: "condition" }, mapConditionToLabel(classified.condition)),
            React.createElement("small", null,
                "Sist oppdatert: ",
                humanTimeDiff(classified.lastChanged
                    || classified.timeCreated, Date.now()))),
        actionButton);
};
var ClassifiedCard = function (props) {
    var classified = props.classified, _a = props.onUserContact, onUserContact = _a === void 0 ? function () { return null; } : _a, _b = props.isEditable, isEditable = _b === void 0 ? false : _b, _c = props.shouldFocus, shouldFocus = _c === void 0 ? false : _c, _d = props.isOwnedByUser, isOwnedByUser = _d === void 0 ? false : _d;
    var pickup = buildPickupLocation(classified);
    var price = classified.price > 0 ? classified.price + ",-" : 'Gis Bort!';
    return React.createElement("div", { className: "object classified" + (shouldFocus ? ' focus' : '') },
        React.createElement("section", { className: "pickup" },
            React.createElement("h3", null, pickup.name),
            pickup.detail),
        React.createElement("strong", { className: "price" }, price),
        isEditable
            ? React.createElement(EditableContent, null)
            : React.createElement(NonEditableContent, { onUserContact: onUserContact, classified: classified, isOwnedByUser: isOwnedByUser }));
};
export default ClassifiedCard;
